<main>
	<div
		class="page-layout"
		data-qa="page-not-found"
	>
		<div class="content">
			<h1>404</h1>
			<div class="main-text">
				<div>
					<div class="heading">
						<div class="icon">
							<app-icon
								icon="information"
								iconSize="64"
							></app-icon>
						</div>
						<div class="text">Not found...</div>
					</div>
					<p class="description-text">Looks like you are lost.</p>
					<div class="description">
						<p class="mt-3 description-text">
							This page does not exist. Check the URL or return to the
							<a href="/">Home Page</a>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>
